module.exports = __webpack_public_path__ + "static/crew-static-c0b3e71f690a49a3830702972ec5cd11.jpg";